import type { Dispatch } from "redux";
import * as accountTransactions from "./accountTransactions";
import * as app from "./app";
import * as bankAccounts from "./bankAccounts";
import * as countries from "./countries";
import * as customer from "./customer";
import * as documents from "./documents";
import * as error from "./error";
import * as flyt from "./flyt";
import * as flyttPkb from "./flyttPkb";
import * as fondsskole from "./fondsskole";
import * as holdingsHistory from "./holdingsHistory";
import * as init from "./init";
import * as investmentPrograms from "./investmentPrograms";
import * as kartlegging from "./kartlegging";
import * as log from "./log";
import * as norskPensjon from "./norskPensjon";
import * as policies from "./policies";
import * as prices from "./prices";
import * as prognosis from "./prognosis";
import * as samtykke from "./samtykke";
import * as sl from "./sl";
import * as uiState from "./uiState";
import * as utbetalingsoversikt from "./utbetalingsoversikt";
import type { State } from "../reducers";

type DispatcherFunc = (...args: any) => (dispatch: any, getState: any) => any;

type NewDispatcherFunc<T extends DispatcherFunc> =
	ReturnType<T> extends (dispatch: any) => infer P
		? (...args: [...Parameters<T>]) => (dispatch: Dispatch, getState?: () => State, errorHandler?: (e) => any) => P
		: (...args: [...Parameters<T>]) => (dispatch: Dispatch, getState: () => State, errorHandler?: (e) => any) => ReturnType<ReturnType<T>>;

type Dispathers = {
	[P in keyof typeof dispatchersObj]: NewDispatcherFunc<(typeof dispatchersObj)[P]>;
};

const dispatchersObj = {
	...accountTransactions,
	...app,
	...bankAccounts,
	...countries,
	...customer,
	...documents,
	...error,
	...fondsskole,
	...investmentPrograms,
	...holdingsHistory,
	...log,
	...norskPensjon,
	...policies,
	...prognosis,
	...samtykke,
	...sl,
	...flyttPkb,
	...uiState,
	...utbetalingsoversikt,
	...prices,
	...kartlegging,
	...flyt,
	...init,
};

const dispatchers = Object.entries(dispatchersObj).reduce(
	(result, [name, dispatcher]) => ({
		...result,
		[name]:
			(...args) =>
			(dispatch, getState, errorHandler) =>
				Promise.resolve(dispatcher(...args)(dispatch, getState)).catch((e) => (errorHandler ? errorHandler(e) : dispatch(error.dispatchError(e)))),
	}),
	{},
) as Dispathers;

export default dispatchers;
